import React from "react";
import { Row, Spin, Col, DatePicker, Space, message, Radio, Tag } from "antd";
import "./ShoppingReport.css";
import { useState } from "react";
import { useEffect } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import moment from "moment";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import TableWidget from "./TableWidget/TableWidget";
import "jspdf-autotable";
import { empty, getCurrencyInfo, isEmpty } from "utils/GlobalFunctions";
import * as XLSX from "xlsx";
import type { PaginationProps } from "antd";
import { Pagination } from "antd";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { apiGetٍShoppingInventoryName } from "services/InventoryGroupService";
import { apiExportExcellShoppingInvName } from "services/reportService";
const { RangePicker } = DatePicker;

function ShoppingReport() {
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [searchList, setSearchList] = useState([]);

  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchText, setSearchText] = useState("");
  const [needReresh, setNeedRefresh] = useState("");

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    pageSize
  ) => {
    setPageSize(pageSize);
    setCurrentPage(current);
  };
  const onChange: PaginationProps["onChange"] = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    setIsBusy(true);
    apiGetٍShoppingInventoryName(
      currentPage,
      pageSize,
      startDate,
      endDate,
      searchText
    )
      .then((data) => {
        setIsBusy(false);
        if (data.nameList === undefined) {
          setIsBusy(false);
          setDataList([]);
          setSearchList([]);
        } else {
          setIsBusy(false);
          setDataList(data.nameList);
          setSearchList(data.nameList);
        }
        setTotalCount(data.total_count);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Sorry! " + err);
      });
  }, [pageSize, currentPage, startDate, endDate, searchText, needReresh]);

  useEffect(() => {}, []);

  const handleSearch = (text) => {
    setCurrentPage(1);
    setSearchText(text.toLowerCase());
  };
  const handleChange = (event) => {
    setCurrentPage(1);
    if (event.target.value === "") {
      setSearchText("");
    } else {
      handleSearch(event.target.value);
    }
  };
  const handleDateFilter = (startDate, endDate) => {
    setCurrentPage(1);
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const exportExcel = () => {
    setIsBusy(true);
    apiExportExcellShoppingInvName()
      .then((data) => {
        setIsBusy(false);
        processExportFunc(data);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const processExportFunc = (tmpList) => {
    if (tmpList.length == 0) {
      message.info("There is no low stock inventory");
      return;
    }
    let wb = XLSX.utils.book_new();
    let tmpData = [];
    tmpData.push([
      "ID",
      "Thumbnail",
      "Name",
      "Qty",
      "Low Qty Limit",
      "Unit",
      "Average Cost/Unit",
      "Selling Price Percentage",
      "Selling Price",
      "Salable",
      "Updated At",
    ]);
    tmpList.map((y) => {
      let cost = "$(" + getCurrencyInfo() + ") " + y.average_price_per_unit;
          let sell_price_percentage = parseFloat(y.sell_price_percentage).toFixed(2);
          let sell_price = ""
          if (y.sell_price_percentage == "0") {
            sell_price = "---";
          } else {
            sell_price = "$(" +
                  getCurrencyInfo() +
                  ") " +
                  parseFloat(
                    (100 * y.average_price_per_unit) /
                      y.sell_price_percentage
                  ).toFixed(2)
          }
          let salable = ""
          if (y.salable === "1") {
            salable = "Yes";
          } else {
            salable = "No";
          }
          tmpData.push([
            y.id,
            y.thumbnail_image,
            y.name,
            y.qty,
            y.low_qty,
            y.unit.name,
            cost,
            sell_price_percentage,
            sell_price,
            salable,
            y.update_timestamp
          ]);
    });

    let ws = XLSX.utils.aoa_to_sheet(tmpData);
    XLSX.utils.book_append_sheet(wb, ws, "");
    XLSX.writeFile(wb, "low_stock_inventory.xlsx");
  }

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <Row justify="space-between">
          <Col>
            <div className="text-header">Low Stock Inventory Report</div>
          </Col>
          <Col>
            <CommonButton
              onClick={() => {
                exportExcel();
              }}
              style={{ margin: 10 }}
            >
              Export XLXS
            </CommonButton>
          </Col>
        </Row>

        <div>
          <Row>
            <Col>
              <div style={{ fontFamily: "mediumFont", padding: 20 }}>
                Date Filter Period : &nbsp;&nbsp;
                <RangePicker
                  size={"default"}
                  onChange={(e, date) => {
                    if (date == null) {
                      handleDateFilter("", "");
                    } else {
                      handleDateFilter(date[0], date[1]);
                    }
                  }}
                />
              </div>
            </Col>
            <Col flex={"auto"}>
              <div style={{ fontFamily: "mediumFont", padding: 20 }}>
                <TitleSearch
                  onSearch={handleSearch}
                  onChange={handleChange}
                  onPressEnter={handleSearch}
                />
              </div>
            </Col>
          </Row>
          <Row justify={"center"}>
            <Col>
              <Pagination
                showSizeChanger
                onShowSizeChange={onShowSizeChange}
                onChange={onChange}
                defaultCurrent={1}
                current={currentPage}
                total={totalCount}
                pageSize={pageSize}
              />
            </Col>
          </Row>
          <div>
            <TableWidget dataList={searchList} setDataList={setSearchList} />
          </div>
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default ShoppingReport;
